var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{ref:"dropdown",staticClass:"nav-item dropdown"},[_c('button',{staticClass:"nav-link pb-0 pr-0",on:{"click":_vm.toggleDropdown}},[_vm._t("dropdown-button")],2),(_vm.isOpen)?_c('DropdownMenu',{attrs:{"size":_vm.size}},[_vm._t("dropdown-menu")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }